.Main a {
    border-bottom: solid 2px currentColor;
}

.Column {
    padding: 0 0 var(--space) 0;
}

.Title {
    padding-bottom: var(--small-space);
    margin-bottom: var(--small-space);
    border-bottom: solid 2px currentColor;
}

.Content {
    display: grid;
    grid-gap: var(--small-space);
    grid-template-columns: repeat(auto-fit, minmax(var(--large-space), auto));
}

.Text {
    line-height: 1.7;
}

.Image {
    display: grid;
    justify-content: end;
}

.Image img {
    width: 100%;
    height: 100%;
    max-width: calc(var(--large-space) * 1.5);
    max-height: var(--large-space);
    object-fit: contain;
    object-position: top right;
}

@media (min-width: 768px) {

    .Main {
        display: grid;
        grid-gap: var(--small-space);
        grid-template-columns: repeat(14, minmax(0, 1fr));
    }

    .Main > :nth-child(1) {
        grid-column: 1 / span 4;
    }

    .Main > :nth-child(2) {
        grid-column: 6 / span 4;
    }

    .Main > :nth-child(3) {
        grid-column: 11 / span 4;
    }
}